import type {ConferenceApiModel} from '../../../api/conference';
import type {Nullable} from '../../utility-types';

import {isDefined} from '../../typecheck';
import {isChatConference} from './isChatConference';

export const isConferenceStarted = (
  conference?: Nullable<ConferenceApiModel>,
) => {
  const isOngoingStatus = conference?.status === 'ongoing';
  const hasSessionId = isDefined(conference?.session_id);

  const verdictByType = isChatConference(conference)
    ? isOngoingStatus
    : isOngoingStatus && hasSessionId;

  return isDefined(conference) && verdictByType;
};
